// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-b1769ce6] {\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  margin-top: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
